<template>
  <div class="product-upload">
    <div class="row col-md-12 flex-wrap justify-content-center ml-0 pl-0 pr-0">
      <div
        class="receiptUploaderWrapper col-xs-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center"
      >
        <div class="receiptScannerPlaceholder" v-show="!selectedFile?true:false">
          <img src="../../assets/icons/form/receipt.svg" alt="Receipt" />
          <p class="mt-2 mb-0 text-center">
            <strong class="text-center">{{this.texts.product}}</strong>
          </p>
          <p class="mt-2 text-center w-75">{{this.texts.productFieldDescription}}</p>
        </div>
        <div v-if="selectedFile" class="row row-dop d-flex justify-content-center">
          <label class="wrapper_square_img">
            <img
              class="square-img img-fluid"
              ref="preview"
              src="../../assets/icons/placeholder.svg"
              alt
            />
            <div @click="removeImage" class="delete_block">
              <img class="delete_img" src="../../assets/icons/delete.svg" alt />
            </div>
          </label>
        </div>
      </div>
      <div class="uploadInputSection col-xs-12 col-md-8 col-xl-8 pl-0 pr-0">
        <div class="container container-md pr-md-0" style="height: 100%; padding-bottom: 20px;">
          <div class="wrapper_file_upload" style="height: 100%">
            <label
              class="file_upload p-5"
              :style="`border-color: ${colorSchema}`"
              @mouseover="uploadSectionHover = true"
              @mouseleave="uploadSectionHover = false"
            >
              <div class="file_upload_background" :style="`background-color: ${colorSchema}`"></div>
              <div>
                <input
                  @change="onFilePicked"
                  accept="image/*,application/pdf"
                  class="inputfile"
                  type="file"
                  name="file"
                  ref="file"
                />
                <div
                  class="position-relative justify-content-center w-100 mb-2"
                  style="height: 48px; margin-left: -20px;"
                >
                  <transition-group name="fade" mode="out-in">
                    <svg
                      class="uploadIcon"
                      key="notFilled"
                      v-if="!uploadSectionHover"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="24"
                        cy="24"
                        r="23.5"
                        transform="rotate(-180 24 24)"
                        :stroke="colorSchema"
                      />
                      <path
                        d="M25.375 33C26.0512 33 26.6 32.4512 26.6 31.775V21.975H31.5L24.15 14.625L16.8 21.975H21.7V31.775C21.7 32.4512 22.2488 33 22.925 33H25.375Z"
                        :fill="colorSchema"
                      />
                    </svg>
                    <svg
                      class="uploadIcon"
                      key="filled"
                      v-else
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="24"
                        cy="24"
                        r="24"
                        transform="rotate(-180 24 24)"
                        :fill="colorSchema"
                      />
                      <path
                        d="M25.375 33C26.0512 33 26.6 32.4512 26.6 31.775V21.975H31.5L24.15 14.625L16.8 21.975H21.7V31.775C21.7 32.4512 22.2488 33 22.925 33H25.375Z"
                        fill="white"
                      />
                    </svg>
                  </transition-group>
                </div>

                <div class="text_min color-gray fw-500" v-html="this.texts.receiptUpload">
                </div>
                <div class="uploadDescription color-gray" v-html="this.texts.receiptUploadDescription"></div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-upload",
  props: {
    fieldId: String,
    apiUrl: String,
    successAction: {
      type: Object,
      required: true
    },
    value: {
      required: false
    },
    title: {
      type: String,
      default: "Laden Sie Ihr Foto hoch"
    },
    uploadText: {
      type: String,
      default: "Datei auswählen"
    },
    colorSchema: {
      required: false,
      type: String,
      default: "#8B8B8B"
    },
    tokenName: {
      required: false,
      type: String,
      default: "token"
    },
    reUpload: {
      required: false,
      type: Boolean
    },
    texts: {
      required: false,
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      selectedFile: null,
      uploadSectionHover: false
    };
  },
  components: {},
  methods: {
    clear () {
      this.selectedFile = null;
      this.setValue(null);
    },
    removeImage () {
      this.selectedFile = null;
      this.setValue(null);
      this.$refs.file.value = null;
    },
    onFilePicked (event) {
      const files = event.target.files || event.dataTransfer.files;
      const maxfilesize = 1024 * 1024 * 16; // 1 Mb

      if (files && files[0]) {
        let filename = files[0].name;

        if (filename && filename.lastIndexOf(".") <= 0) {
          return;
        }
        if (files[0].size > maxfilesize) {
          this.showModal(this.texts.fileSizeLimit);
          return;
        }
        const extension = files[0].name.split(".").pop();
        const found = ["png", "jpg", "jpe", "jpeg", "tiff", "pdf"].filter(
          ext => ext === extension.toLowerCase()
        );
        if (!found.length) {
          this.showModal(this.texts.wrongFormat);
          return;
        }
        this.selectedFile = files[0];
        this.setPreview(this.selectedFile);
        this.setValue(this.selectedFile);
      }
    },
    setValue (value) {
      this.$emit("component-updated", {
        value
      });
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: !!value
      });
    },
    setPreview (file) {
      const reader = new FileReader();

      this.selectedFile = file;
      reader.onload = e => {
        this.$refs.preview.src = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    sendProductPhoto (formId, triggers) {
      const formData = {
        image: this.selectedFile,
        apiUrl: this.apiUrl,
        receiptToken: this.$store.getters.receiptToken
      };

      if (this.reUpload) {
        formData["receiptToken"] = this.$route.query[this.tokenName];
        formData["customerToken"] = 1;
        // console.log("REUPLOAD",this.reUpload, formData)
      }

      this.$store.dispatch("uploadProductPhotos", formData).then(r => {
        // console.log(this.successAction, this.response);
        if (r.response && this.successAction) {
          const fn = this.successAction.fn;
          const params = this.successAction.params;
          this[fn](params, this);
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: true
          });
        }
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false,
          message: r.message || "Unexpected Error",
          invalid_fields: r.invalid_fields || []
        });
      });
    }
  },
  mounted () {
    if (this.value) {
      this.setPreview(this.value);
    }
    this.$eventHub.$on("sendProductPhotos-event", this.sendProductPhoto);
  }
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: 0.4s;
}
.uploadIcon {
  position: absolute;
  top: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.uploadDescription {
  font-size: 12px;
  line-height: 22px;
}
.receiptUploaderWrapper {
  border: 1px solid #dddfe1;
  box-sizing: border-box;
  border-radius: 4px;
  min-height: 240px;
  padding: 0;
  margin-bottom: 20px;
  width: 86%;
  .receiptScannerPlaceholder {
    color: #97999b;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.text-center {
  text-align: center !important;
}
.file_upload {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  border: 1px dashed #009639;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  &:hover {
    & .file_upload_background {
      opacity: 0.2;
      transition: 0.4s ease-in-out;
    }
  }
  & .file_upload_background {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.4;
    z-index: -1;
    background-color: #009639;
    opacity: 0.06;
    transition: 0.4s;
  }
}
.file_upload input[type="file"] {
  display: none;
}
.hidden {
  display: none;
}
.receipt-uploader {
  overflow: hidden;
}

.wrapper_square_img {
  position: relative;
  display: inline-block;
  width: 89%;
}
.delete_block {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}
.delete_block .delete_img {
  width: 16px;
}
.section-title {
  color: #474747;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.16px;
  text-align: center;
  margin-bottom: 30px;
}
.upload-canvas {
  box-sizing: border-box;
  height: 176px;
  border: 2px dashed #979797;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  transition: background-color 0.5s;
  cursor: pointer;

  &:hover {
    background-color: #fff;
  }

  .upload-text {
    color: #474747;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.16px;
  }

  .upload-icon {
    text-align: center;
  }
}
.upload-hint {
  margin-top: 14px;
  opacity: 0.64;
  color: #474747;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.14px;
  line-height: 16px;
}
.inputfile {
  display: none;
}
</style>
